import React from 'react';

function TimerCard({ type, value, children, onChange }) {
  return (
    <div
      className={`timer-card ${value === type ? 'timer-card-selected' : ''}`}
      onClick={() => onChange(type)}
    >
      {children}
    </div>
  );
}

export { TimerCard };
